/**
 * @generated SignedSource<<469fe079691d1e2689c7111ac9e94a51>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment$data = {
  readonly by: {
    readonly displayName: string | null | undefined;
  } | null | undefined;
  readonly when: string | null | undefined;
  readonly " $fragmentType": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment";
};
export type useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment$key = {
  readonly " $data"?: useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "displayName"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ],
  "type": "Version"
};

(node as any).hash = "e1d2099945c80fbb0be34791a561397b";

export default node;
